import * as XLSX from 'xlsx';

const reportFileName = (name) => {
  switch (name) {
    case "disbursements":
      return "Desembolso";
    case "physical_financials":
      return "Previsto";
    case "paid_values":
      return "Pago";
    case "to_pay_values":
      return "A Pagar";
    case "advancements":
      return "Ajustes de desembolso";
    case "ampli_disbursements":
      return "Previsão de desembolso";
    case "all":
      return "Relatório Geral";
    case "all_by_wbs":
      return "Relatório Geral Completo";
    default:
      return name;
  }
};

const toWorksheet = (fields, resources) => XLSX.utils.json_to_sheet(
  resources.map(resource => {
    const row = {};
    fields.forEach(field => {
      if (field.key === "building_unit_name") {
        row[field.label] = resource.building_unit_name ?? resource.description ?? '';
      } else {
        row[field.label] = resource[field.key] ?? '';
      }
    });
    return row;
  })
);

// Aba montada célula a célula: `rows` é a grade (linha 1 primeiro), `merges` são
// intervalos `{ s: { r, c }, e: { r, c } }` com índices a partir de 0 e `cols` as larguras
// (`{ wch }`). Serve para cabeçalhos de duas linhas, que `json_to_sheet` não monta.
const toGridWorksheet = ({ rows, merges = [], cols }) => {
  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  if (merges.length > 0) worksheet['!merges'] = merges;
  if (cols) worksheet['!cols'] = cols;
  return worksheet;
};

// Uma aba por item de `sheets`, na ordem recebida: `{ name, fields, resources }` (uma
// linha por recurso) ou `{ name, rows, merges, cols }` (grade pronta). O Excel limita o
// nome da aba a 31 caracteres.
export const downloadWorkbook = (e, sheets, name = "") => {
  e.preventDefault();

  const workbook = XLSX.utils.book_new();
  sheets.forEach((sheet) => {
    const worksheet = sheet.rows ? toGridWorksheet(sheet) : toWorksheet(sheet.fields, sheet.resources);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name.slice(0, 31));
  });

  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', reportFileName(name) + " " + new Date().toLocaleString().replace(/[/,:]/g, '-') + '.xlsx');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadCsv = (e, fields, resources, name = "") => {
  downloadWorkbook(e, [{ name: 'Sheet1', fields, resources }], name);
};

// Função auxiliar para converter string para array buffer
function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }
  return buf;
}
